fragment flexibleQuote on flexibleSections_quote_BlockType {
    __typename
    ... on flexibleSections_quote_BlockType {
        id
        quoteText: plaintext
        captionText: richTextMinimal
    }
}
